/** Arabic for text inside the generated dashboard boards, applied by i18n/dom.ts (batch 5). Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "Running late": "متأخر عن الجدول",
  "Non-conformances": "حالات عدم المطابقة",
  "Schedule performance": "أداء الجدول الزمني",
  "progress against the planned curve": "التقدم مقابل المنحنى المخطط",
  "Cost performance": "أداء التكلفة",
  "work earned against money spent": "قيمة العمل المنجز مقابل المبالغ المصروفة",
  "Forecast overrun": "التجاوز المتوقع",
  "spend rate against progress": "معدل الصرف مقابل التقدم",
  "Projects running late": "المشاريع المتأخرة",
  "forecast completion against contract": "الإنجاز المتوقع مقابل العقد",
  "Non-conformances open": "حالات عدم المطابقة المفتوحة",
  "quality inspections": "فحوص الجودة",
  "Quality checklist complete": "اكتمال قائمة فحص الجودة",
  "site quality checks": "فحوص الجودة في الموقع",
  "Engineering confirmation": "التأكيد الهندسي",
  "engineering confirmatory checklist": "قائمة التأكيد الهندسي",
  "Gates signed": "البوابات الموقّعة",
  "acceptance and testing gates": "بوابات القبول والاختبار",
  "PORTFOLIO REPORT": "تقرير المحفظة",
  Programme: "البرنامج",
  "How the budget, spend and forecast are worked out": "كيف تُحسب الميزانية والصرف والتوقع",
  "The white post is the budget and the diamond is the forecast at the current spend rate. A diamond past the post is an overrun that has already happened, whatever the contract still says.":
    "العمود الأبيض هو الميزانية، والمعيّن هو التوقع بمعدل الصرف الحالي. المعيّن بعد العمود تجاوزٌ وقع بالفعل، مهما قال العقد.",
  "Acceptance and testing gates": "بوابات القبول والاختبار",
  "What each gate means and who can sign it": "معنى كل بوابة ومن يحق له توقيعها",
  "FORECAST END": "الانتهاء المتوقع",
  Rehabilitation: "إعادة تأهيل",
  "Major improvement": "تحسين رئيسي",
  "AGL contractor": "مقاول AGL",
  Upgrade: "ترقية",
  "BHS supplier": "مورّد BHS",
  "Not yet awarded": "لم تتم الترسية بعد",
  "New construction": "إنشاء جديد",
  "Emergency works": "أعمال طارئة",
  "Where it stands": "الوضع الحالي",
  "Pick a project": "اختر مشروعًا",
  "Open one for its gates, quality checks, the engineering confirmatory list, notes and its own report.":
    "افتح مشروعًا لترى بواباته وفحوص الجودة وقائمة التأكيد الهندسي والملاحظات وتقريره الخاص.",
  Accepted: "مقبول",
  "With comments": "مع ملاحظات",
  "Rejections not cleared": "رفض لم يُغلق",
  "Checks failed": "فحوص لم تنجح",
  "First time acceptance": "القبول من المرة الأولى",
  "First time acceptance is the honest measure of a contractor's quality system. A discipline that only ever passes on re-inspection is telling you the work is being built to be corrected rather than built right.":
    "القبول من المرة الأولى هو المقياس الصادق لنظام الجودة لدى المقاول. التخصص الذي لا ينجح إلا عند إعادة الفحص يخبرك أن العمل يُنفَّذ ليُصحَّح لا ليُنفَّذ صحيحًا.",
  "Rejections still open": "حالات رفض ما زالت مفتوحة",
  "A rejection stays open until a re-inspection against the same activity is accepted. Signing a later gate does not clear it.":
    "يبقى الرفض مفتوحًا حتى تُقبل إعادة فحص للنشاط نفسه. توقيع بوابة لاحقة لا يغلقه.",
  "RAISE AN INSPECTION": "طلب فحص",
  "INSPECTION REPORT": "تقرير الفحص",
  REF: "المرجع",
  ACTIVITY: "النشاط",
  "Mechanical and MEP": "الأعمال الميكانيكية وMEP",
  "ACCEPTED WITH COMMENTS": "مقبول مع ملاحظات",
  "Asphalt and pavement": "الأسفلت والرصف",
  "Engineering inspections": "الفحوص الهندسية",
  "What the inspections say": "ما تُظهره الفحوص",
  "Open a record": "افتح سجلًا",
  "Each carries its ITP and specification reference, the measured values against the stated tolerance, the accept or reject decision and the inspector's note.":
    "يحمل كل سجل مرجع ITP والمواصفة، والقيم المقاسة مقابل التفاوت المحدد، وقرار القبول أو الرفض، وملاحظة الفاحص.",
  "Work orders open — click to see where this number comes from and how it is worked out":
    "أوامر العمل المفتوحة — انقر لترى مصدر هذا الرقم وكيف يُحسب",
  "Work orders open": "أوامر العمل المفتوحة",
  "HOW THIS IS WORKED OUT →": "كيف يُحسب هذا ←",
  "In progress — click to see where this number comes from and how it is worked out":
    "قيد التنفيذ — انقر لترى مصدر هذا الرقم وكيف يُحسب",
  "Findings open — click to see where this number comes from and how it is worked out":
    "الملاحظات المفتوحة — انقر لترى مصدر هذا الرقم وكيف يُحسب",
  "Findings open": "الملاحظات المفتوحة",
  "Safety critical — click to see where this number comes from and how it is worked out":
    "حرجة للسلامة — انقر لترى مصدر هذا الرقم وكيف يُحسب",
  "Assessments failed or overdue — click to see where this number comes from and how it is worked out":
    "تقييمات لم تنجح أو متأخرة — انقر لترى مصدر هذا الرقم وكيف يُحسب",
  "Assessments failed or overdue": "تقييمات لم تنجح أو متأخرة",
  "Incidents open — click to see where this number comes from and how it is worked out":
    "الحوادث المفتوحة — انقر لترى مصدر هذا الرقم وكيف يُحسب",
  "Incidents open": "الحوادث المفتوحة",
  "Working as": "تعمل باسم",
  unattributed: "غير منسوب",
  "SET YOUR NAME": "حدّد اسمك",
  "OPEN THE LOG": "افتح السجل",
  "the aerodrome, georeferenced": "المطار بإحداثيات جغرافية",
  "OPEN →": "فتح ←",
  "programme, budget and acceptance": "البرنامج والميزانية والقبول",
  "Where this rating comes from": "مصدر هذا التقييم",
  "buildings and infrastructure register": "سجل المباني والبنية التحتية",
  "floor plans, rooms and the work in them": "مخططات الطوابق والغرف والأعمال فيها",
  "kerb, car parks and the approach": "الرصيف ومواقف السيارات والطريق المؤدي",
  "access roads, kerb and parking": "طرق الوصول والرصيف والمواقف",
  "checklists, findings and the work they raise": "قوائم الفحص والملاحظات والأعمال الناتجة عنها",
  "Assessments and testing": "التقييمات والاختبارات",
  "surveys, tests and certificates": "المسوحات والاختبارات والشهادات",
  "surveys, comparison and trend": "المسوحات والمقارنة والاتجاه",
  "accumulation, removal and verification": "التراكم والإزالة والتحقق",
  "Raise something without leaving this page": "أنشئ طلبًا دون مغادرة هذه الصفحة",
  "NEW WORK ORDER": "أمر عمل جديد",
  "NEW WORK ORDER HERE": "أمر عمل جديد هنا",
  "START AN INSPECTION": "بدء فحص",
  "FILE AN ASSESSMENT": "تسجيل تقييم",
  "Each opens the same form the module uses, so nothing is recorded twice or differently depending on where it was entered.":
    "كلٌّ منها يفتح النموذج نفسه الذي تستخدمه الوحدة، فلا يُسجَّل شيء مرتين أو بشكل مختلف حسب مكان إدخاله.",
  "Who is on the job": "من يعمل على المهمة",
  "In house": "داخلي",
  "Agency · Mutual aid agreement": "جهة · اتفاقية مساعدة متبادلة",
  "Click one for the contract, the scope, every open job against them and a number that dials. The count is what they are carrying now; late is measured against each job's own response time.":
    "انقر على أحدها لترى العقد والنطاق وكل مهمة مفتوحة عليه ورقمًا للاتصال. العدد هو ما يحمله الآن؛ والتأخر يُقاس بزمن الاستجابة الخاص بكل مهمة.",
  "Latest work": "أحدث الأعمال",
  "Entries this session": "إدخالات هذه الجلسة",
  "Records changed": "السجلات المعدّلة",
  "Field changes": "تغييرات الحقول",
  "Search the log — a record, a field, a person": "ابحث في السجل — سجل أو حقل أو شخص",
  "PRINT THE LOG": "طباعة السجل",
  WHO: "من",
  "WHAT CHANGED": "ما الذي تغيّر",
  "switched to the dark view": "التبديل إلى العرض الداكن",
  session: "الجلسة",
  "The log lives for as long as the page is open. It is a working record, not evidence — there is no access control in this file, so a name here is a claim about who acted, not proof of it.":
    "يبقى السجل ما دامت الصفحة مفتوحة. هو سجل عمل لا دليل — لا يوجد تحكم في الوصول في هذا الملف، فالاسم هنا ادعاء بمن قام بالإجراء لا إثبات له.",
  "Open findings": "الملاحظات المفتوحة",
  "Last inspection": "آخر فحص",
  "no baseline yet": "لا يوجد خط أساس بعد",
  FACILITY: "المنشأة",
  GROUP: "المجموعة",
  CRIT: "الأهمية",
  "LAST INSPECTION": "آخر فحص",
  Masjid: "مسجد",
  "Public facilities": "المرافق العامة",
  "not located": "غير محدد الموقع",
  "Ministry of Hajj Building": "مبنى وزارة الحج",
  "Goods Delivery / eastern airside–landside gate": "استلام البضائع / البوابة الشرقية بين الجانب الجوي والجانب الأرضي",
  "Access & security": "الدخول والأمن",
  "Monumental Gateway": "البوابة التذكارية",
  "Guard House — Security": "غرفة الحراسة — الأمن",
  "Power Plant": "محطة الكهرباء",
  Utilities: "المرافق الخدمية",
  "District Cooling": "تبريد المناطق",
  "Water Plant": "محطة المياه",
  "Sewage Treatment Plant": "محطة معالجة الصرف الصحي",
  "Warehouse / Material Storage": "المستودع / تخزين المواد",
  Support: "الدعم",
  "Waste Management Facility": "منشأة إدارة النفايات",
  "Electrical distribution": "التوزيع الكهربائي",
  "Guard Cantonment & Housing": "معسكر الحراسة والسكن",
  Housing: "السكن",
  "Family Housing": "سكن العائلات",
  "Bachelor Housing": "سكن العزاب",
  "Landside Civil Works & Infrastructure": "الأعمال المدنية والبنية التحتية في الجانب الأرضي",
  "Civil works": "الأعمال المدنية",
  "area-wide": "على مستوى المنطقة",
  "GACA Administration Building": "مبنى إدارة الهيئة العامة للطيران المدني",
  "Areas inspected as a whole rather than as a single building — kerbside, parking, roads and staging. They carry the landside checklist and their findings attach to the zone.":
    "مناطق تُفحص ككل لا كمبنى واحد — الرصيف والمواقف والطرق ومناطق الانتظار. تحمل قائمة فحص الجانب الأرضي وتُربط ملاحظاتها بالمنطقة.",
  "Terminal forecourt and kerbside": "ساحة مبنى الركاب والرصيف",
  INSPECT: "فحص",
  "Access roads and interchange": "طرق الوصول والتقاطع",
  "Taxi and bus staging": "منطقة انتظار سيارات الأجرة والحافلات",
  "Nothing outstanding on the landside.": "لا شيء معلق في الجانب الأرضي.",
  "Roads, parking, kerbside and the estate outside the fence": "الطرق والمواقف والرصيف والمنشآت خارج السياج",
  Inspect: "فحص",
  "QUICK LANDSIDE INSPECTION": "فحص سريع للجانب الأرضي",
  "DETAILED LANDSIDE INSPECTION": "فحص مفصل للجانب الأرضي",
  Report: "التقرير",
  "SHORT REPORT": "تقرير مختصر",
  "DETAILED REPORT": "تقرير مفصل",
  DOMAIN: "المجال",
  "Passenger Terminal Building": "مبنى الركاب",
  "New Terminal": "مبنى الركاب الجديد",
  "ARFF — Aerodrome Rescue & Fire Fighting Building": "ARFF — مبنى الإنقاذ ومكافحة الحرائق في المطار",
  "Aviation safety": "سلامة الطيران",
  "Hajj Pavilions": "أجنحة الحج",
  "Pilgrim facilities": "مرافق الحجاج",
  "Hajj Check-In Building": "مبنى إنهاء إجراءات الحج",
  "AGL Substation (North)": "محطة AGL الفرعية (الشمالية)",
  "Airfield electrical": "كهرباء الجانب الجوي",
  "AGL Substation (South)": "محطة AGL الفرعية (الجنوبية)",
  "Airside Civil Works & Infrastructure": "الأعمال المدنية والبنية التحتية في الجانب الجوي",
  "ATC — Air Traffic Control": "ATC — مراقبة الحركة الجوية",
  "Royal Pavilions": "الأجنحة الملكية",
  "Sub ARFF — Aerodrome Rescue & Fire Fighting Building": "ARFF الفرعي — مبنى الإنقاذ ومكافحة الحرائق في المطار",
  "Pick a facility from the register. Each one carries its group, the inspection domain its checklist comes from, a criticality, and whatever has been raised against it.":
    "اختر منشأة من السجل. تحمل كل منشأة مجموعتها، ومجال الفحص الذي تأتي منه قائمة فحصها، ودرجة أهميتها، وكل ما سُجّل عليها.",
  Pinned: "مثبّت",
  "placed on the plan": "موضوع على المخطط",
  "Awaiting a location": "بانتظار تحديد الموقع",
  "tap PIN on any row": "اضغط تثبيت في أي صف",
  "Area-wide": "على مستوى المنطقة",
  "civil works, no single point": "أعمال مدنية، دون نقطة محددة",
  PIN: "تثبيت",
  "Nothing raised against a facility yet. Open one from the register and start an inspection or create a new work order — everything filed against it lands here.":
    "لم يُسجَّل شيء على أي منشأة بعد. افتح منشأة من السجل وابدأ فحصًا أو أنشئ أمر عمل — كل ما يُسجَّل عليها يظهر هنا.",
  ROOMS: "الغرف",
  "ROOM CODES": "رموز الغرف",
  "HEAT MAP": "الخريطة الحرارية",
  "ACTIVE WORKSITES": "مواقع العمل النشطة",
  "not calibrated — distances unknown": "غير معايَر — المسافات غير معروفة",
  "NOT CALIBRATED": "غير معايَر",
  "CALIBRATE THE SCALE": "معايرة المقياس",
  "Inspect this level": "افحص هذا الطابق",
  "QUICK BUILDING INSPECTION": "فحص سريع للمبنى",
  "DETAILED BUILDING INSPECTION": "فحص مفصل للمبنى",
  "Largest spaces": "أكبر المساحات",
  Attachments: "المرفقات",
  "Search title, area, contractor or standard": "ابحث بالعنوان أو المنطقة أو المقاول أو المعيار",
  "ADD A RECORD": "إضافة سجل",
  ASSESSMENT: "التقييم",
  "Runway friction survey": "مسح احتكاك المدرج",
  current: "ساري",
  "Standby generator load bank test": "اختبار حمل المولد الاحتياطي",
  "Generator load bank test": "اختبار حمل المولد",
  "Lift and escalator statutory examination": "الفحص النظامي للمصاعد والسلالم المتحركة",
  "Statutory lift and escalator": "الفحص النظامي للمصاعد والسلالم المتحركة",
  "Terminal vertical transport": "النقل الرأسي في مبنى الركاب",
  "LV distribution insulation and earth loop testing": "اختبار العزل وحلقة التأريض لتوزيع الجهد المنخفض",
  "Electrical testing and earthing": "الاختبارات الكهربائية والتأريض",
  "AGL photometric survey": "المسح الضوئي لـ AGL",
  "Movement area pavement condition survey": "مسح حالة الرصف في منطقة الحركة",
  "Pavement condition survey": "مسح حالة الرصف",
  "Runways, taxiways and apron": "المدارج وممرات الطائرات وساحة وقوف الطائرات",
  "What the testing says": "ما تُظهره الاختبارات",
  "By type": "حسب النوع",
  "Cycles are the platform's defaults for each type until the aerodrome manual sets its own. A record with no attachment is a claim; attach the report and it becomes evidence.":
    "الدورات هي الإعدادات الافتراضية للمنصة لكل نوع حتى يحدد دليل المطار دوراته. السجل دون مرفق ادعاء؛ أرفق التقرير ليصبح دليلًا.",
  "Reports on file": "التقارير المحفوظة",
  "From assessments": "من التقييمات",
  "From inspections": "من الفحوص",
  "Readable in the page": "قابلة للقراءة في الصفحة",
  "Registered only": "مسجلة فقط",
  "Records with nothing attached": "سجلات بلا مرفقات",
  "Search by file name, assessment or reference": "ابحث باسم الملف أو التقييم أو المرجع",
  "Passed outright": "ناجح بالكامل",
  "With observations": "مع ملاحظات",
  "Conditional or failed": "مشروط أو لم ينجح",
  "Reports attached": "التقارير المرفقة",
  "Records with no report": "سجلات بلا تقرير",
  "Results by assessment type": "النتائج حسب نوع التقييم",
  "Recall profile": "جدول الاستحقاق",
  "Overdue is shown separately from the coming months because it is not a future commitment — it is a lapse that already happened.":
    "يُعرض المتأخر منفصلًا عن الأشهر القادمة لأنه ليس التزامًا مستقبليًا — بل تقصير وقع بالفعل.",
  "What the assessments found": "ما وجدته التقييمات",
  "Failed:": "لم ينجح:",
  "Conditional:": "مشروط:",
  "Overdue:": "متأخر:",
  "No report on file:": "لا يوجد تقرير محفوظ:",
  "Bands below planning": "النطاقات دون مستوى التخطيط",
  "Runway PCI": "PCI المدرج",
  "Taxiway PCI": "PCI ممر الطائرات",
  "Apron PCI": "PCI ساحة وقوف الطائرات",
  "Fittings measured": "الوحدات المقاسة",
  Replaced: "المستبدلة",
  "Units examined": "الوحدات المفحوصة",
  "Units tested": "الوحدات المختبرة",
  "Worst changeover": "أسوأ زمن تحويل",
  "Circuits tested": "الدوائر المختبرة",
  "Values are as the assessor reported them. Adding them to a record makes the register searchable on the numbers rather than only on the conclusion.":
    "القيم كما أبلغ عنها المقيّم. إضافتها إلى السجل تجعل البحث في السجل ممكنًا بالأرقام لا بالخلاصة وحدها.",
  "Every record, by date": "كل السجلات حسب التاريخ",
  BUILDING: "المبنى",
  "START INSPECTION": "بدء الفحص",
  Inspector: "الفاحص",
  "Name / licence": "الاسم / الرخصة",
  "No open findings.": "لا توجد ملاحظات مفتوحة.",
  "Nothing filed yet.": "لم يُسجَّل شيء بعد.",
  "Terminal zones": "مناطق مبنى الركاب",
  "Landside zones": "مناطق الجانب الأرضي",
  "Overdue work orders": "أوامر العمل المتأخرة",
  "past their target date": "تجاوزت تاريخها المستهدف",
  "Evidence completeness": "اكتمال الأدلة",
  "open findings carrying a photograph": "ملاحظات مفتوحة مرفقة بصورة",
  "Rubber status": "حالة المطاط",
  "runway ends past the removal level": "أطراف المدرج التي تجاوزت مستوى الإزالة",
  "Certification readiness by domain": "جاهزية الاعتماد حسب المجال",
  "no detailed inspection": "لا يوجد فحص مفصل",
  Building: "المبنى",
  "Short reports are the one-page position for a daily or weekly meeting. Detailed reports carry every checklist line, its result, the inspector's note and the photographs, which is the form an audit will ask for.":
    "التقارير المختصرة هي موقف من صفحة واحدة لاجتماع يومي أو أسبوعي. أما التقارير المفصلة فتحمل كل بند في قائمة الفحص ونتيجته وملاحظة الفاحص والصور، وهي الصيغة التي سيطلبها التدقيق.",
  SHORT: "مختصر",
  "AIRPORT OVERALL": "المطار ككل",
  "All three domains, findings, work orders, rubber and friction status":
    "المجالات الثلاثة والملاحظات وأوامر العمل وحالة المطاط والاحتكاك",
  "Single facility": "منشأة واحدة",
  "— choose a facility —": "— اختر منشأة —",
  "Lightning protection system": "نظام الحماية من الصواعق",
  "Airfield ground lighting — CAT III": "الإنارة الأرضية للمطار — CAT III",
  "CAT III lighting system approval": "اعتماد نظام إنارة CAT III",
  GACA: "الهيئة العامة للطيران المدني",
  "Lifting equipment and slings": "معدات الرفع والحمالات",
  "Thorough examination of lifting equipment": "الفحص الشامل لمعدات الرفع",
  "Ground support equipment": "معدات الخدمة الأرضية",
  "GSE inspection and roadworthiness": "فحص GSE وصلاحية السير",
  "Continuous friction measuring device": "جهاز قياس الاحتكاك المستمر",
  "Device correlation and calibration": "مطابقة الجهاز ومعايرته",
  "Screening officers": "موظفو التفتيش الأمني",
  "Screener certification currency": "سريان شهادات موظفي التفتيش",
  "Potable water system": "نظام مياه الشرب",
  "Water quality certification": "شهادة جودة المياه",
  "Fire detection and alarm system": "نظام كشف الحريق والإنذار",
  "Runway declared distances and surface condition": "المسافات المعلنة للمدرج وحالة السطح",
  "Tank integrity and hydrant pressure test": "اختبار سلامة الخزان وضغط صنابير الإطفاء",
  "Breathing apparatus sets": "أجهزة التنفس",
  "Cylinder test and set service": "اختبار الأسطوانات وصيانة الأجهزة",
  "Cabin baggage X-ray and body scanners": "أجهزة الأشعة لأمتعة المقصورة وماسحات الجسم",
  "Equipment approval and image quality": "اعتماد المعدات وجودة الصورة",
  "Airside driving permits": "تصاريح القيادة في الجانب الجوي",
  "Airside driver certification": "اعتماد السائقين في الجانب الجوي",
  "Hold baggage screening — EDS units": "تفتيش أمتعة العنبر — وحدات EDS",
  "Detection standard approval and daily test regime": "اعتماد معيار الكشف ونظام الاختبار اليومي",
  "ARFF appliances — foam output": "آليات ARFF — إنتاج الرغوة",
  "Foam proportioning and discharge test": "اختبار نسب خلط الرغوة وتصريفها",
  "Fire pumps and sprinkler system": "مضخات الحريق ونظام الرشاشات",
  "Pump performance test": "اختبار أداء المضخات",
  "Pressure vessels and air receivers": "أوعية الضغط وخزانات الهواء",
  "Written scheme of examination": "خطة الفحص المكتوبة",
  "Machinery safety and emergency stop conformity": "سلامة الآلات ومطابقة الإيقاف الطارئ",
  "Electrical installation — fixed wiring": "التمديدات الكهربائية — الأسلاك الثابتة",
  "Sweepers and airfield plant": "الكناسات ومعدات الجانب الجوي",
};
export default ar;
